import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const HIDDEN_PREFIXES = ['/admin', '/checkout'];

/**
 * 3CX Live Chat widget.
 *
 * Rendered only if an admin has explicitly toggled it on
 * (checkout_settings.livechat_3cx_enabled). By default it is hidden.
 */
const LiveChatWidget = () => {
  const { pathname } = useLocation();
  const [enabled, setEnabled] = useState(false);

  useEffect(() => {
    let cancelled = false;
    axios
      .get(`${API}/checkout-settings`)
      .then((res) => {
        if (!cancelled) setEnabled(Boolean(res.data?.livechat_3cx_enabled));
      })
      .catch(() => {});
    return () => {
      cancelled = true;
    };
  }, []);

  const hiddenByRoute = HIDDEN_PREFIXES.some((p) => pathname.startsWith(p));
  if (!enabled || hiddenByRoute) return null;

  return (
    <div id="pactac-3cx-livechat" data-testid="livechat-widget-root">
      <call-us-selector
        phonesystem-url="https://1346.3cx.cloud"
        party="beaminglimited"
      ></call-us-selector>
    </div>
  );
};

export default LiveChatWidget;
